import sidePanel from 'side-panel-menu-thing'
import BigPicture from 'bigpicture'
import lozad from 'lozad'
import QuoteBanner from '../components/quote-banner.svelte'
// import ShowCalendar from '../components/show-calendar.svelte'
import Popup from '../components/member-popup.svelte'

const { $ } = window
const $body = $(document.body)
const body = document.body

export default {
	init() {
		document.addEventListener("DOMContentLoaded", function() {
			let $html = $('html');
			let $body = $('body');
			let $backdrop = $('.backdrop');
			let $siteHeader = $('.site-header');
			let $mobileMenu = $('.mobile-menu');
			let $dropdowns = $mobileMenu.find('.menu-item.menu-item-has-children');
			let $openMenuButton = $('.mobile-menu__open-button');
			let $closeMenuButton = $('.mobile-menu__close-button');

			$openMenuButton.click(function (e) {
				e.stopPropagation();
				$html.addClass('no-scroll');
				$body.addClass('hamburger-menu-is-open');
				$backdrop.fadeIn();
				$mobileMenu.addClass('open');
			});

			$closeMenuButton.click(function () {
				$html.removeClass('no-scroll');
				$body.removeClass('hamburger-menu-is-open');
				$backdrop.fadeOut();
				$mobileMenu.removeClass('open');
			});

			$dropdowns.each(function () {
				let $dropdown = $(this);
				let $submenu = $dropdown.children('.sub-menu');
				let $openTimeout, $closeTimeout;

				$dropdown.on('mouseenter', function () {
					clearTimeout($closeTimeout);

					$openTimeout = setTimeout(() => {
						$dropdowns
							.not($dropdown)
							.removeClass('active')
							.each(function () {
								$(this)
									.children('.sub-menu')
									.stop(true, true)
									.slideUp(300);
							});

						$dropdown.addClass('active');

						$submenu
							.stop(true, true)
							.slideDown(300);
					}, 150);
				});

				$dropdown.on('mouseleave', function () {
					clearTimeout($openTimeout);

					$closeTimeout = setTimeout(() => {
						$submenu.stop(true, true).slideUp(300);
						$dropdown.removeClass('active');
					}, 600);
				});
			});

			$(window).on('resize', function () {
				let $isDesktop = $(window).width() >= 1280;
				let $bodyHasMenuClass = $body.hasClass('hamburger-menu-is-open');

				if ($isDesktop && $bodyHasMenuClass) {
					$html.removeClass('no-scroll');
					$backdrop.stop(true, true).fadeOut();
				}

				else if (!$isDesktop && $bodyHasMenuClass) {
					$html.addClass('no-scroll');
					$backdrop.stop(true, true).fadeIn();
				}
			});
		});
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
		let $article = $('.page-template-default')

		quoteBanner()
		// showCalendar()

		lazyLoad()

		checkWebp()
		// videoFuncYT()

		// class to hide outlines if not using keyboard
		$body.on('mousedown', function () {
			$body.addClass('using-mouse')
		})
		$body.on('keydown', function () {
			$body.removeClass('using-mouse')
		})

		// article enlarge images
		if ($article.length) {
			$article
				.find(
					'.wp-block-image a[href*=".jpg"], .wp-block-image a[href*=".jpeg"]'
				)
				.on('click', function (e) {
					const $this = $(this)
					const $imgEls = $this.find('img')
					e.preventDefault()
					BigPicture({
						el: $imgEls.length ? $imgEls[0] : this,
						imgSrc: this.href,
					})
				})
		}

		let $membersPage = $('.page-template-members')
		if ($membersPage.length) {
			new Popup({
				target: document.body,
			})
		}

		let $packagePage = $('.page-template-season-tickets')
		if ($packagePage.length) {
			new Popup({
				target: document.body,
			})
		}

		let $wpBlockImg = $('.wp-block-image')
		if ($wpBlockImg.length) {
			$wpBlockImg.on('click', function (e) {
				const $this = $(this)
				const $imgEls = $this.find('img')
				e.preventDefault()
				BigPicture({
					el: $imgEls.length ? $imgEls[0] : this,
					imgSrc: this.href,
				})
			})
		}

		let $blocksGallery = $('.wp-block-gallery .wp-block-image  > a')
		if ($blocksGallery.length) {
			let $caption = $('.blocks-gallery-item__caption')
			if ($caption) {
				$caption.each(function () {
					$(this).siblings('a')[0].setAttribute('data-caption', $(this).text())
				})
			}

			$blocksGallery.each(function (index, el) {
				el.setAttribute('data-bp', el.href)
			})

			$blocksGallery.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
					gallery: '.wp-block-gallery',
					loop: true,
					noLoader: true,
				})
			})
		}

		let $singlefeatImg = $('.single-feat-img')
		if ($singlefeatImg.length) {
			$singlefeatImg.on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
				})
			})
		}

		let $singleClass = $('.single-class')
		if ($singleClass.length) {
			$('.class-featured-images > div').on('click', function (e) {
				e.preventDefault()
				BigPicture({
					el: this,
				})
			})
		}
	},
}

function showCalendar() {
	let $calendar = $('#show_calendar')
	if ($calendar.length) {
		new ShowCalendar({
			target: $calendar[0],
			props: $calendar.data(),
		})
	}
}

function quoteBanner() {
	let { bannerQuotes, classQuotes, theatreQuotes } = window
	if (bannerQuotes) {
		new QuoteBanner({
			target: document.body,
			intro: true,
			props: { bannerQuotes, classQuotes, theatreQuotes },
		})
	}
}

function lazyLoad() {
	let $lazyLoadEls = $('.lozad')
	if ($lazyLoadEls.length) {
		let observer = lozad('.lozad', {
			rootMargin: '10px 0px', // syntax similar to that of CSS Margin
			threshold: 0.01, // ratio of element convergence
			enableAutoReload: true, // it will reload the new image when validating attributes changes
		})
		observer.observe()
	}
}

function checkWebp() {
	if (!window.createImageBitmap) {
		$body.addClass('no-webp')
	}
	// var elem = document.createElement('canvas')
	// if (!!(elem.getContext && elem.getContext('2d'))) {
	// 	let supported = elem.toDataURL('image/webp').indexOf('data:image/webp') == 0
	// 	if (!supported) {
	// 		$body.addClass('no-webp')
	// 	}
	// }
}

// function videoFuncYT() {
// 	$(document).ready(function () {
// 		$('.nh-item a, .pd-video > a').on('click', function (e) {
// 			e.preventDefault()
// 			let $this = $(this)
// 			let ytSrc = $this.data('yt')
// 			$this.parent().addClass('showingvid')
// 			BigPicture({
// 				el: this,
// 				ytSrc,
// 				animationEnd() {
// 					$this.parent().removeClass('showingvid')
// 				},
// 			})
// 		})
// 	})
// }
